import React from "react";
import { Link } from "react-router-dom";

const blogs = [
  {
    id: 1,
    title: "Microsoft Copilot: Transforming Business Productivity in 2025",
    author: "Admin",
    date: "September 25, 2025",
    image:
      "https://www.microsoft.com/en-us/microsoft-365/blog/wp-content/uploads/sites/2/2025/09/M365_Copilot1_Blog_250909-809x455.webp",
    excerpt:
      "See how Microsoft Copilot boosts productivity with AI-powered automation, helping teams collaborate smarter in Microsoft 365.",
    link: "/blog/how-microsoft-copilot-is-transforming-business-productivity",
  },
  {
    id: 2,
    title: "Top 7 Benefits of RaaS for Growing Businesses",
    author: "Admin",
    date: "September 25, 2025",
    image:
      "https://partner.microsoft.com/-/media/mssc/mpn/partner/community/subsidiary-images/mpn-apac-partner-hub/intelligentcloudresources-11-fwf-900x506.jpg?h=506&iar=0&w=900&hash=73B14C9898ADA356FAEFAD734C4F127C",
    excerpt:
      "Discover how Resource-as-a-Service helps businesses scale faster, reduce costs, and access expert IT talent on demand.",
    link: "/blog/raas-benefits-for-growing-companies",
  },
  {
    id: 3,
    title: "Microsoft Power Platform: The Future of Low-Code Solutions",
    author: "Admin",
    date: "September 25, 2025",
    image:
      "https://cdn-dynmedia-1.microsoft.com/is/image/microsoftcorp/valprop41?resMode=sharp2&op_usm=1.5,0.65,15,0&wid=905&qlt=100&fmt=png-alpha&fit=constrain",
    excerpt:
      "Explore how Power Platform enables faster innovation with low-code tools like Power Apps, Power BI, and Power Automate.",
    link: "/blog/microsoft-power-platform-future-low-code-business-solutions",
  },
  {
    id: 4,
    title: "Microsoft Azure in 2025: Why Enterprises Are Moving to Cloud",
    author: "Admin",
    date: "September 25, 2025",
    image:
      "https://cdn-dynmedia-1.microsoft.com/is/image/microsoftcorp/Hero_ResourceMgmt_2x_RE27Fne?resMode=sharp2&op_usm=1.5,0.65,15,0&wid=1921&qlt=100&fmt=png-alpha&fit=constrain",
    excerpt:
      "Learn why enterprises choose Microsoft Azure for scalability, security, and AI-powered cloud innovation in 2025.",
    link: "/blog/why-enterprises-are-moving-to-microsoft-azure-2025",
  },
  {
    id: 5,
    title: "Microsoft 365 Business Premium: Complete Guide for SMEs in 2025",
    author: "Admin",
    date: "October 15, 2025",
    image:
      "https://res.cloudinary.com/dbitupkaa/image/upload/v1743690770/10657_Hero_image-1536x863_c1xzwo.jpg",
    excerpt:
      "Discover how Microsoft 365 Business Premium secures data, boosts productivity, and simplifies IT for small and mid-sized businesses.",
    link: "/blog/microsoft-365-benefits-for-business",
  },
  {
    id: 6,
    title: "Unlock Collaboration with Microsoft SharePoint | Business Guide",
    author: "Admin",
    date: "October 15, 2025",
    image:
      "https://res.cloudinary.com/dbitupkaa/image/upload/v1739174180/37ee888ef8ea4447940a9c0a148bb1f7_vk8gtg.jpg",
    excerpt:
      "Learn how Microsoft SharePoint enables secure document sharing, teamwork, and workflow automation for modern  businesses.",
    link: "/blog/microsoft-sharepoint-benefits-for-business",
  },
  {
    id: 7,
    title: "Microsoft Teams Phone: System Benefits for Businesses",
    author: "Admin",
    date: "October 15, 2025",
    image:
      "https://res.cloudinary.com/dbitupkaa/image/upload/v1760522902/Image_Option1_Customer_Story_703x443_j3tr52.avif",
    excerpt:
      "Learn how Microsoft Teams Phone streamlines communication, enhances collaboration, and boosts productivity for businesses.",
    link: "/blog/microsoft-teams-phone-system-benefits-for-business",
  },
  {
    id: 7,
    title:
      "Why Microsoft Defender for Endpoint is Essential for Business Security",
    author: "Admin",
    date: "October 22, 2025",
    image:
      "https://res.cloudinary.com/dbitupkaa/image/upload/v1737555031/Safeguard-your-data-card_axqj7d.jpg",
    excerpt:
      "Microsoft Defender for Endpoint (MDE) is an enterprise-grade security platform that helps organizations prevent, detect, investigate, and respond to advanced cyber threats.",
    link: "/blog/why-microsoft-defender-for-endpoint-is-essential-for-business-security",
  },
  {
    id: 7,
    title: "Microsoft 365 for Businesses: Key Benefits and Security Measures",
    author: "Admin",
    date: "November 04, 2025",
    image:
      "https://res.cloudinary.com/dbitupkaa/image/upload/v1739174180/37ee888ef8ea4447940a9c0a148bb1f7_vk8gtg.jpg",
    excerpt:
      "Microsoft 365 empowers Indian businesses with secure, cloud-based collaboration and productivity tools like Teams, SharePoint, and OneDrive.",
    link: "/blog/microsoft-365-for-indian-businesses",
  },
];

const BlogCard = () => {
  // Sort blogs by date (newest first)
  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {sortedBlogs.map((blog) => (
          <Link
            to={blog.link}
            key={blog.id}
            className="group block bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-1"
          >
            <div className="relative overflow-hidden h-64 sm:h-72 md:h-64 lg:h-72">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <div className="p-5 sm:p-6">
              <p className="text-sm text-gray-500 mb-2">
                By {blog.author} | {blog.date}
              </p>
              <h2 className="text-lg sm:text-xl font-semibold mb-3 text-gray-800 group-hover:text-[#ba195f] transition-colors">
                {blog.title}
              </h2>
              <p className="text-gray-600 mb-4 text-sm sm:text-base">
                {blog.excerpt}
              </p>
              <span className="text-[#ba195f] font-semibold text-sm group-hover:underline">
                Read more →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogCard;
